"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PEPGuideConfigAnswer =
/**
 *
 * @param {Object} config
 * @param {string} config.text The text for the answer
 * @param {string} config.feature The name of the feature to filter on, if this answer is chosen
 * @param {(boolean|number|string)} config.featureValue The value to pass to the filter, if this answer is chosen
 */
function PEPGuideConfigAnswer(config) {
  _classCallCheck(this, PEPGuideConfigAnswer);

  /**
   * The text for the answer
   * @type {string}
   */
  this.text = config.Text || config.text || '';
  /**
   * The name of the feature to filter on, if this answer is chosen
   * @type {string}
   */

  this.feature = config.Feature || config.feature || '';
  /**
   * The value to pass to the filter, if this answer is chosen
   * @type {(boolean|number|string)}
   */

  this.featureValue = config.FeatureValue || config.featureValue || '';
};

var _default = PEPGuideConfigAnswer;
exports["default"] = _default;